
import { computed, defineComponent, PropType } from 'vue'
import {
  ConsolidatedDataType,
  ConsolidatedTableType,
  PeriodontalReportType,
  CommentType,
} from '@/shared/types'
import { WConsolidatedReport } from '@/widgets/WConsolidatedReport'
import { EPeriodontalGraphic } from '@/entities/EPeriodontalGraphic'
import { EPeriodontalMapTable } from '@/entities/EPeriodontalMapTable'
import { LOGO } from '@/shared/constants'

export default defineComponent({
  name: 'SecondPdfPage',
  components: {
    WConsolidatedReport,
    EPeriodontalMapTable,
    EPeriodontalGraphic,
  },

  props: {
    data: Object as PropType<PeriodontalReportType>,
    plaque: Number,
    bleeding: Number,
    pockets: Number,
    pocketsTable: Array as PropType<ConsolidatedTableType[]>,
    comments: Array as PropType<CommentType[]>,
    consolidatedData: Object as PropType<ConsolidatedDataType>,
  },

  setup(props) {
    const lastComment = computed(
      (): CommentType => props.comments[props.comments.length - 1]
    )

    return {
      lastComment,
      LOGO,
    }
  },
})
